export default __webpack_public_path__ + "static/media/cer12.dadae907.png";